import { fmt, type UiStrings } from '@/constants/ui-locale'
import type { SharedRoomProjectReason } from './sharedRoomPresentation'

export function sharedRoomProjectMismatchNotice(
  t: UiStrings,
  reason: SharedRoomProjectReason,
  roomKey: string
): string {
  switch (reason) {
    case 'majority':
      return fmt(t.sharedRoomProjectNoticeMajority, { project: roomKey })
    case 'title':
      return fmt(t.sharedRoomProjectNoticeTitle, { project: roomKey })
    case 'access':
      return fmt(t.sharedRoomProjectNoticeAccess, { project: roomKey })
    case 'first_joined':
      return fmt(t.sharedRoomProjectNoticeFirstJoined, { project: roomKey })
    case 'manual':
      return fmt(t.sharedRoomProjectNoticeManual, { project: roomKey })
    default:
      return fmt(t.sharedRoomProjectNoticeMajority, { project: roomKey })
  }
}

export function sharedRoomProjectManualChangedToast(
  t: UiStrings,
  changedBy: string,
  projectKey: string
): string {
  return fmt(t.sharedRoomProjectToastManual, { name: changedBy, project: projectKey })
}
